// extracted by mini-css-extract-plugin
module.exports = {"Gameboard":"Gameboard_Gameboard__WLhJg"};